<template src="./template.html"></template>

<script>
export default {
  name: 'select-quantity',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
    },
    min: {
      type: Number,
      default: 1,
    },
  },
  watch: {
    value(val) {
      this.innerValue = val
    },
  },
  data() {
    return {
      innerValue: null,
    }
  },
  methods: {
    updateValue(newVal) {
      this.innerValue = newVal

      this.update()
    },
    update() {
      const newVal = parseInt(this.innerValue, 10)

      this.$emit('input', newVal)
      this.$emit('change', newVal)
    },
  },
  mounted() {
    this.innerValue = this.value
  },
}
</script>



// WEBPACK FOOTER //
// src/components/SelectQuantity/index.vue